module.exports = __webpack_public_path__ + "img/keystore.956cbf72.svg";